module.exports = __webpack_public_path__ + "media/images/application/template/map-pin-ea4f3598c914198527d507c5f183cf20.png";